import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { quickBetIcon } from '../shared-styles';

export const BookmakerCellBase = styled.div<{
  backgroundColour: string;
}>`
  --oc-bookie-background: ${props => props.backgroundColour};

  background: var(--oc-bookie-background, transparent);

  height: 36px;
  margin-bottom: 0;
  position: relative;
  border-radius: 5px;
  & .${quickBetIcon} {
    position: absolute;
    right: 0;
    top: 0;
    bottom: unset;
    transform: translateY(-3px);

    @media (min-width: 768px) {
      [data-testid='odds-grid']:not([data-enforce-mobile]) & {
        position: absolute;
        top: unset;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 50%);
      }
    }
  }
`;

export const BookmakerCellContainer = styled(BookmakerCellBase)`
  border-radius: var(--ogm-grid-bookmaker-cell-border-radius-mobile);

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      height: var(--ogm-grid-bookmaker-cell-height-desktop);
      width: var(--ogm-grid-bookmaker-cell-width-desktop);
      border-radius: var(--ogm-grid-bookmaker-cell-border-radius-desktop);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media (min-width: 1024px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      &:hover {
        box-shadow: 0 2px 4px 0 var(--oc-text-subtext);
      }
    }
  }
`;

export const BookmakerCellContainerSmallIcon = styled(BookmakerCellBase)`
  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      height: var(--ogm-grid-column-height);
      margin-top: calc(var(--ogm-grid-bookmaker-cell-height-desktop) - var(--ogm-grid-column-height));
    }
  }
`;

export const ImgWrapper = styled.span`
  display: flex;
  justify-items: center;
  align-items: center;
  height: 35px;
  width: 136px;
  padding: 0 10px;
  overflow: hidden;

  &.offer {
    width: 100%;
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      padding: 0;
      height: var(--ogm-grid-bookmaker-cell-height-desktop);
      width: var(--ogm-grid-cell-width-desktop);
      overflow-x: hidden;

      display: flex;
      justify-content: center;
      align-items: center;

      > Picture {
        transform: rotate(-90deg) scale(var(--ogm-grid-bookmaker-cell-scale-desktop));
      }
    }
  }
`;

export const ImgWrapperSmallIcons = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 10px;
  overflow: hidden;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      height: 100%;
      width: 100%;
      padding: 0;
      overflow-x: hidden;
    }
  }
`;

export const bookmakerImg = css`
  display: flex;
  justify-items: center;
  align-items: center;
  position: relative;
  object-fit: contain;
  left: 0;
`;

export const bookmakerImgSmallIcon = css`
  display: flex;
  justify-items: center;
  align-items: center;

  object-fit: contain;
`;
